import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import BucketHeaderContainer from '@alias/BucketHeaderContainer';
import injectIntl, { intlShape } from 'common/injectIntl';
import bootstrapSelector from 'common/selectors/bootstrapSelector';
import { dateFormatSelector } from 'common/selectors/appSelector';
import pageSelector from 'common/selectors/pageSelector';
import heroSelector from 'common/selectors/heroSelector';
import { placementPrefixSelector } from 'common/selectors/analyticsSelectors';
import scheduleModuleBucketsSelector, { scheduleModuleNameSelector } from 'common/selectors/scheduleModuleBucketsSelector';
import { BucketStatus, ContentType, ContentStatus } from 'enums';
import ScheduleEventCard from './ScheduleEventCard';

const CONTENT_LIMIT = 4;

export const ScheduleModule = ({
    buckets,
    scheduleModuleName,
    contentLimit = CONTENT_LIMIT,
    bootstrap: { scheduleModule = {} },
    page,
    hero,
    placementPrefix,
    messages,
    intl: { formatMessage },
    intlDateFormat
}) => {
    const { noHero } = page;
    let classes = 'contentCollection contentCollection--watchSchedule sub-module';
    let headerTitle = formatMessage(messages['schedule.module.header.live']);    // should never actually use this default
    let logo;
    let alertThreshold;
    let schedPageHref = 'schedule';
    let placement = placementPrefix; // nielsen placement
    let targetBucket;
    let unSortedContents = [];

    if (buckets.length === 1) {
        const bucket = buckets[0];
        const { tags: origTags = [] } = bucket;
        const tags = [...origTags];
        const upcomingTagIndex = tags.indexOf(BucketStatus.WEB_UPCOMING);
        const liveTagIndex = tags.indexOf(BucketStatus.WEB_LIVE);
        if (upcomingTagIndex !== -1) {
            headerTitle = formatMessage(messages['schedule.module.header.upcoming.on']);
            tags.splice(upcomingTagIndex, 1);
        } else if (liveTagIndex !== -1) {
            headerTitle = formatMessage(messages['schedule.module.header.live']);
            tags.splice(liveTagIndex, 1);
        }

        const pageName = tags.pop();
        const scheduleModuleConfig = scheduleModule[scheduleModuleName];
        let channel = '';
        if (scheduleModuleConfig) {
            channel = scheduleModuleConfig.channel;
            logo = {
                src: scheduleModuleConfig.logo,
                alt: pageName
            };
        }
        alertThreshold = 0;
        placement += 'upcoming';
        schedPageHref += `?type=upcoming${channel ? `&channel=${channel}` : ''}`;
        targetBucket = bucket;
    }

    // page specific schedule module not found, now find the default live or upcoming schedule module feed
    if (!targetBucket) {
        buckets.some((bucket) => {
            const { tags = [] } = bucket;
            if (
                (noHero || (hero && (hero.type === ContentType.VOD || hero.status === ContentStatus.REPLAY))) &&
                tags.indexOf(BucketStatus.WEB_LIVE) !== -1
            ) {
                headerTitle = formatMessage(messages['schedule.module.header.live']);
                placement += 'top-live';
                classes += ' live';
                targetBucket = bucket;
                return true;
            } else if (
                (noHero || (hero && (hero.type === ContentType.LISTING && hero.status !== ContentStatus.REPLAY))) &&
                tags.indexOf(BucketStatus.WEB_UPCOMING) !== -1
            ) {
                headerTitle = formatMessage(messages['schedule.module.header.upcoming']);
                placement += 'upcoming';
                schedPageHref += '?type=upcoming';
                targetBucket = bucket;
                return true;
            }
            return false;
        });
    }

    if (targetBucket) {
        unSortedContents = targetBucket.contents;
    }

    const eventDateNextDayString = formatMessage(messages['schedule.module.eventDate.tomorrow']);

    const contents = unSortedContents
        .slice(0, contentLimit)
        .sort((contentA, contentB) => {
            const aDate = new Date(contentA.utc || contentA.time);
            const bDate = new Date(contentB.utc || contentB.time);
            return aDate.getTime() - bDate.getTime();
        });

    const cards = contents.map((content) =>
        <ScheduleEventCard
            key={`eventcard-${content.name}`}
            content={content}
            placement={placement}
            dateFormat={intlDateFormat}
            alertThreshold={alertThreshold}
            formatMessage={formatMessage}
            messages={messages}
            nextDayString={eventDateNextDayString}
        />
    );

    return (contents.length > 0) ? (
        <section style={{ zIndex: 300 }} className={classes}>
            <BucketHeaderContainer
                appPageTitle={'Schedule'}
                name={headerTitle}
                logo={logo}
                link={schedPageHref}
            />
            {cards}
        </section>
    ) : null;
};

ScheduleModule.propTypes = {
    buckets: PropTypes.array,
    scheduleModuleName: PropTypes.string,
    contentLimit: PropTypes.number,
    bootstrap: PropTypes.object,
    page: PropTypes.object,
    hero: PropTypes.object,
    placementPrefix: PropTypes.string,
    intl: intlShape.isRequired,
    intlDateFormat: PropTypes.string,
    messages: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
    buckets: scheduleModuleBucketsSelector(state),
    scheduleModuleName: scheduleModuleNameSelector(state),
    bootstrap: bootstrapSelector(state),
    page: pageSelector(state),
    hero: heroSelector(state),
    placementPrefix: placementPrefixSelector(state),
    intlDateFormat: dateFormatSelector(state)
});

export default connect(mapStateToProps)(injectIntl(ScheduleModule));



// WEBPACK FOOTER //
// ./app/webapp/scheduleModule/ScheduleModuleContainer.js